import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable, timer } from 'rxjs';
import { retry } from 'rxjs/operators';
import { NO_GLOBAL_RETRY, RETRY_CONFIG } from './retry.tokens';
import { RetryService } from '../services/retry.service';

@Injectable()
export class RetryInterceptor implements HttpInterceptor {
  constructor(private retryService: RetryService) {}

  public intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const noRetry = req.context.get(NO_GLOBAL_RETRY);
    if (noRetry) {
      return next.handle(req);
    }

    const cfg = req.context.get(RETRY_CONFIG);
    const methodOk = cfg.retryMethods?.includes(req.method.toUpperCase());
    if (!methodOk) {
      return next.handle(req);
    }

    return next.handle(req).pipe(
      retry({
        count: cfg.attempts,
        delay: (error, retryCount) => {
          if (!this.retryService.shouldRetry(error, cfg)) {
            throw error;
          }

          const delayMs = this.retryService.getDelay(
            error,
            retryCount - 1,
            cfg
          );
          return timer(delayMs);
        },
      })
    );
  }
}
